const initialState = {
  page_heading: ''
};

const pageHeadingReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_PAGE_HEADING':
      return {
        ...state,
        page_heading: action.payload
      };
    default:
      return state;
  }
};

export default pageHeadingReducer;
